<template>
	<q-layout view="hHh lpr fFf">


		<q-page-container>
			<q-page>

				<div class="bg-gris">
					<q-toolbar class="header-toolbar">
						<q-toolbar-title>
							<img src="https://cdn.greenpeace.fr/images/logos/greenpeace-white.svg" class="header-logo"/>
						</q-toolbar-title>
					</q-toolbar>
				</div>


				<div class="col-width text-center text-noir">
					<h1 class="title q-pb-lg">
						Végé à la cantine : <em>passez à l’action&nbsp;!</em>
					</h1>
				</div>

				<div class="col-width text-center text-noir">
					<p>
						<b>Les enfants mangent au moins 2 fois trop de viande, souvent de piètre qualité, dans les cantines scolaires</b> par rapport aux recommandations sanitaires. Une aberration dangereuse pour la santé des enfants (surpoids, obésité, diabète), mais aussi dévastatrice pour la planète. Il est urgent d’y mettre un terme, en proposant plus de menus végétariens et de la viande issue d’élevage vertueux&nbsp;! Pour cela, vous pouvez agir à votre échelle, dans votre commune.
					</p>
				</div>

				<div class="col-width text-center main-cta">
					<div class=" button bg-gris text-white btn-main" @click="goToActions">
						<div>
							<span>Choisissez votre action</span>
							<q-icon name="arrow_forward"/>
						</div>
					</div>
				</div>

				<div class="col-width text-center text-noir jna-video">
					<q-video src="https://www.youtube.com/embed/cIM-NEEtqJ0"/>
				</div>

				<div class="actions-buttons col-width text-center" :class="tab.length ? 'active' : ''" ref="actions">
					<div class="row justify-between items-stretch action-col">
						<action-btn
							v-for="action in actions"
							:key="action[0]"
							:class="tab === action[0] ? 'active' : ''"
							class="col-xs-6 col-sm-3 action-button"
							v-model="tab"
							:name="action[0]"
							:label="action[1]"
							/>
					</div>
				</div>

				<div class="col-width text-noir">
					<q-tab-panels v-model="tab">
						<q-tab-panel
							v-for="action in actions"
							:key="action[0]"
							:name="action[0]"
							>
							<component :is="'action-' + action[0]" :title="action[1]"/>
						</q-tab-panel>
					</q-tab-panels>
				</div>

				<div class="suite">
					<div class="col-width text-center text-noir">

						<h2>
							D’autres personnes agissent déjà... Pourquoi pas vous&nbsp;?
						</h2>

						<q-carousel
							animated
							v-model="slide"
							arrows
							prev-icon="arrow_left"
							next-icon="arrow_right"
							swipeable
							:autoplay="8000"
							infinite
							>
							<q-carousel-slide
								v-for="(s,i) in slides"
								:key="i"
								:name="i"
								:img-src="s.src">
								<div class="custom-caption" v-html="s.caption"></div>
							</q-carousel-slide>
						</q-carousel>
					</div>
				</div>

				<div class="footer-visuel ">
					<img src="https://cdn.greenpeace.fr/images/jna/main-footer.svg"/>
				</div>

				<div class="bg-gris text-white footer text-center">
					<share-items class="footer-share"/>

					<div>
						<img src="https://cdn.greenpeace.fr/images/logos/greenpeace-white.svg" class="footer-logo"/>
					</div>

					<p>
						&copy; Greenpeace France 2019
					</p>

					<div>
						<q-space/>
						<q-btn
						flat stretch
						type="a"
						label="Mentions légales"
						href="https://www.greenpeace.fr/mentions-legales/"
						/>
						<q-btn
						flat stretch
						type="a"
						label="Contact"
						href="https://www.greenpeace.fr/contact/"
						/>
						<q-space/>

					</div>


				</div>


			</q-page>
		</q-page-container>

<!--
		<q-dialog v-model="confirm">
			<q-card class="confirm-modal">
				<q-card-section class="row items-center">
					<q-space />
					<q-btn icon="close" flat round dense v-close-popup />
				</q-card-section>

				<q-card-section class="text-center modal-content">
					<div class="title">
						<em>
							Merci ! 
						</em>
					</div>

					<p>
						Vous avez démontré la complicité de notre gouvernement dans cette affaire. Pour s'assurer que le gouvernement mette un terme à l'élevage industriel et à la déforestation qu'il génère, nous avons créé un mouvement de personnes déterminées à agir. On a besoin de vous dans ce mouvement. Ça serait dommage de vous arrêter là. Vous en êtes&nbsp;? 
					</p>

					<q-btn type="a" class="btn-main modal-btn" label="Je rejoins le mouvement" href="https://www.greenpeace.fr/elevage-la-transition-ecologique-simpose-il-y-a-urgence/?utm_source=preuve-deforestation"/>

					<share-items class="modal-share"/>

				</q-card-section>
			</q-card>
		</q-dialog>
-->

	</q-layout>
</template>

<script>



import HomeScreen from '../components/HomeScreen2.vue'
import ActionsScreen from '../components/ActionsScreen2.vue'
import ShareItems from "../components/ShareItems.vue"

import ActionMaire from '../components/ActionMaire.vue'
import ActionShare from '../components/ActionShare.vue'
import ActionOut from '../components/ActionOut.vue'
import ActionCantineverte from '../components/ActionCantineverte.vue'
import ActionBtn from '../components/ActionBtn.vue'

//import axios from 'axios'
import { scroll } from 'quasar'
const { getScrollTarget, setScrollPosition } = scroll


export default {
	name: 'Index',
	components: {
		HomeScreen,
		ActionsScreen,
		ActionBtn,
		ShareItems,
		ActionMaire,
		ActionShare,
		ActionOut,
		ActionCantineverte,
	},

	methods: {

		onActionDone(what) {
			const params = {}
			params.w = what

			this.$trackEvent("click", "action validée")
/*
			axios.post('./api/action', params, {
				headers: {
					'X-CSRF-TOKEN': this.server_token
				}
			})
			.then( (r) => {
				this.confirm = true

				if (r.data) {
					const id = parseInt(r.data, 10)
					if (!isNaN(id)) {
						this.my_action_id = id
					}
				}

			})
			.catch( (e) => console.log('error', e))
*/
		},
		goToActions() {
			this.$trackEvent("click", "bouton lancement recherche")
			this.scrollTo('actions')
		},
		selectAction(el) {
			this.$nextTick( () => this.doScroll(el))
		},
		scrollTo(id) {
			const ref = this.$refs[id]
			let el = ref.$el ? ref.$el : ref
			this.doScroll(el)

		},
		doScroll(el) {
			const target = getScrollTarget(el)
			const offset = el.offsetTop
			const duration = 750
			setScrollPosition(target, offset, duration)
		}

	},
	data() {
		return {
			slide: "0",
			tab: "",
			actions: [
				['maire', "Interpellez votre maire"],
				['out', "Agissez dans votre commune"],
				['cantineverte', "Rejoignez le mouvement Cantine Verte"],
				['share', "Partagez cette page"],
			],
			slides: [
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Le-Mans-1.jpg', caption: 'Le Mans'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Lyon-1.jpg', caption: 'Lyon'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Nantes-1.jpg', caption: 'Nantes'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Paris-1-e1573230910431.jpg', caption: 'Paris'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Poitiers-1.jpg', caption: 'Poitiers'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Paris-3.jpg', caption: 'Paris'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Le-Mans-2.jpg', caption: 'Le Mans'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Lyon-2.jpg', caption: 'Lyon'},
				{src: 'https://cdn.greenpeace.fr/site/uploads/2019/11/Paris-2.jpg', caption: 'Paris'},

			],
			//server_token: window.$Ktoken ? window.$Ktoken : "",
			//num_concerned: "",
			//num_communes: "",
			//num_actions: "",
			//polling: 0,
			//notifyTimeoutDelay: 6000,
			//my_action_id: 0,
				confirm: false,
			//last_action_id: 0,
		}
	},
	mounted() {
		this.$trackPage(location.href, "")
	}
}

</script>

